var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.polyline.getPath().getArray()),function(point,index){return [(index > 0)?_c('div',{key:index,staticClass:"label",style:(_vm.positions[index])},[_vm._v(" "+_vm._s(`${_vm.getDistances[index - 1].toFixed(1)} m`)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }